import createSagaMiddleware from 'redux-saga';

import { API_FEATURE_KEY, apiMiddleware, apiReducer } from '@client/api';
import { configureStore } from '@reduxjs/toolkit';

import { APP_FEATURE_KEY, appReducer } from './app/app.slice';
import { rootSaga } from './root.saga';
import { SESSION_FEATURE_KEY, sessionReducer } from './session/session.slice';

import { config } from '../config';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    [API_FEATURE_KEY]: apiReducer,
    [APP_FEATURE_KEY]: appReducer,
    [SESSION_FEATURE_KEY]: sessionReducer,
  },
  // Additional middleware can be passed to this array
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Allow Blob objects (they're used for file downloads)
        isSerializable: (value: any, path?: string) => {
          // Allow Blob instances (used for file downloads)
          if (value instanceof Blob) {
            return true;
          }
          // Use default serialization check for everything else
          return (
            typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean' ||
            value === null ||
            value === undefined ||
            Array.isArray(value) ||
            (typeof value === 'object' && value !== null)
          );
        },
      },
    }).concat(sagaMiddleware, apiMiddleware),
  devTools: config.stage !== 'production',
});

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
